import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SideNavMenu from "./SideNavMenu";

// sidenav component
const SideNav = ({ isOpen, toggleSideNav }) => {
  const { i18n } = useTranslation("global");
  const sideNavRef = useRef();

  useEffect(() => {
    const handleClickOutside = event => {
      if (
        isOpen &&
        window.innerWidth < 1200 &&
        sideNavRef.current &&
        !sideNavRef.current.contains(event.target)
      ) {
        toggleSideNav();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside); // for touch devices (iPhone, Android)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isOpen, toggleSideNav]);

  const handleLinkClick = () => {
    if (window.innerWidth < 1200) {
      toggleSideNav();
    }
  };

  return (
    <div
      ref={sideNavRef}
      className={`sidenav ${isOpen ? "openNav" : "closedNav"}`}
      style={{ zIndex: 20000 }}
      onClick={
        !isOpen
          ? e => {
              if (e.target.closest("a")) {
                return;
              }
              if (e.target.closest(".mx-auto")) {
                return;
              }
              if (e.target.closest("img")) {
                return;
              }
              toggleSideNav();
            }
          : undefined
      }
    >
      <span className="closeNav" onClick={toggleSideNav}>
        <i className="bi bi-x"></i>
      </span>
      <div className="mx-auto my-2" style={{ textAlign: "center" }}>
        <Link to="/" onClick={handleLinkClick}>
          <div
            style={{
              textDecoration: "none",
              padding: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <img
              src={i18n.language === "ar" ? "/logoArabic.png" : "/logoEn.png"}
              alt="albaraqawy Logo"
              style={{
                height: "70px",
                width: "auto",
                maxWidth: "100%",
                cursor: "pointer",
              }}
            />
          </div>
        </Link>
      </div>
      <SideNavMenu handleLinkClick={handleLinkClick} />
    </div>
  );
};

export default SideNav;
